import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input() show = false;
  @Input() size = 'big';

  constructor() { }

  ngOnInit() {

  }

  getImage() {
    let image = 'assets/cargando.gif';
    if (this.size === 'small') {
      image = 'assets/cargando-s.gif';
    }
    return  image;
  }

}
